import React, { Component, useEffect } from 'react';
import ChatContainerComponent from 'react/chat/inner/ChatContainerComponent.jsx';
import ChatHeaderBar from './ChatHeaderBar';
import { Dashboard } from '../../components/Dashboard';
import * as matchmakingActions from '../redux/actions/matchmaking';
import * as featuredStreamsActions from '../redux/actions/featuredStreams';
import * as settingsActions from '../redux/actions/settings';
import * as chatActions from '../redux/actions/chat';

import store from 'react/redux/store/store';

import { connect, Provider } from 'react-redux';
import { bindActionCreators } from 'redux';
import StateHelpers from '../redux/store/StateHelpers';
import ChatRulesComponent from './ChatRulesComponent';
import withDefaultProps from 'functions/withDefaultProps';

const defaultProps = {
	isPopup: false,
};

function MainChatHolder(incomingProps) {
	const props = withDefaultProps(incomingProps, defaultProps);
	const {
		activePopupChatMessage, mainChatUserlistToggle,
		aChatHasNewMentions, aChatHasUnreadMessages,
		toggleChatSidebar, windowSizeIsMedium, windowSizeIsLarge, toggleChatVisibleOn, showMainChatAsPopup,
		isPopup, isPinned, toggleMainChatMinimized, chatLargeMinimized, windowSizeIsTiny, toggleShowMainChatAsPopup, toggleChatRules, chatRulesToggledOn,
		windowIsVisible, updateGeneralChatUnreadMessageState,
		pageLayout, peopleOpen, onTogglePeople, onOpenRooms,
	} = props;
	const { selectedMainChat } = props;
	const chatRoom = selectedMainChat;

	useEffect(() => {
		if(windowIsVisible && chatRoom) {
			chatRoom.chatMessages.markAllRead();
			updateGeneralChatUnreadMessageState();
		}
	}, [windowIsVisible]);

	function getChatRoomListProps() {
		const { myChatRooms } = props;
		return {
			chatRoomGroups:
				[
					{ chats: myChatRooms, type: 'main', title: null, sortable: true },
				]
		};
	}


	const showPersistentChatTabs = !isPinned && (windowSizeIsMedium || windowSizeIsLarge);
	const isMinimized = isPinned ? false : StateHelpers.chatIsMinimized();
	const showInlineUserlistOverlay = !isPinned && windowSizeIsLarge;
	const useSidebarToggle = !windowSizeIsLarge;

	return (
		<div id='main_chat_area' className={`${isMinimized ? 'minimized' : 'expanded'}`}>
			<div id='main_chat_holder'>
				<ChatHeaderBar
					chatSidebarToggle={useSidebarToggle ? toggleChatSidebar : undefined}
					bannerIsClickable={!isPinned && !showPersistentChatTabs}
					showPersistentChatTabs={showPersistentChatTabs}
					chatRoom={chatRoom}
					aChatHasUnreadMessages={aChatHasUnreadMessages}
					aChatHasNewMentions={aChatHasNewMentions}
					toggleChatSidebar={toggleChatSidebar}
					toggleMainChatMinimized={toggleMainChatMinimized}
					showMainChatAsPopup={showMainChatAsPopup}
					toggleShowMainChatAsPopup={toggleShowMainChatAsPopup}
					toggleChatRules={toggleChatRules}
					isPopup={isPopup}
					isPinned={isPinned}
					isMinimized={isMinimized}
					pageLayout={pageLayout}
					peopleOpen={peopleOpen}
					onTogglePeople={onTogglePeople}
					onOpenRooms={onOpenRooms}
				/>
				{!isMinimized &&
				<React.Fragment>
					{chatRulesToggledOn &&
					<ChatRulesComponent
						toggleChatRules={toggleChatRules}
					/>
					}

					{!chatRulesToggledOn &&
					<Provider store={store}>
						<ChatContainerComponent
							mainChatUserlistToggle={mainChatUserlistToggle}
							mainChatUserlistToggledOnSetting={showInlineUserlistOverlay}
							chatRoom={chatRoom}
							isActive={true}
							activePopupChatMessage={activePopupChatMessage}
							name={chatRoom && chatRoom.name}
							isDisabled={chatRoom && chatRoom.chatMessages.closed}
							windowSizeIsLarge={windowSizeIsLarge}
							windowSizeIsMedium={windowSizeIsMedium}
							showPersistentChatTabs={showPersistentChatTabs}
							isMinimized={isMinimized}
							isPinned={isPinned}
							{...getChatRoomListProps()}
						/>
					</Provider>
					}
				</React.Fragment>
				}
			</div>

		</div>
	);
}

function mapStateToProps(state) {
	return {
		...state.matchmaking,
		...state.featuredStreams,
		...state.settings,
		...state.chat,
		...state.windowSize,
		...state.popups,
		...state.windowFocus,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		...matchmakingActions,
		...featuredStreamsActions,
		...settingsActions,
		...chatActions,
	}, dispatch);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MainChatHolder);